import type React from 'react'
import { useState } from 'react'
import PageWrapper from '../../../../../../components/Pagewrapper'
import type { PageTab } from '../../../../../../types/internal-types'
import CustomerBreakdownTab from './components/CustomerBreakdownTab'
import SamplingListTab from './components/SamplingListTab'

type FinanstilsynetTab = 'sampling-list' | 'customer-breakdown'

const FinanstilsynetScreen: React.FC = () => {
  const [tab, setTab] = useState<FinanstilsynetTab>('sampling-list')

  const tabs: PageTab[] = [
    {
      title: 'Stikprøveliste',
      active: tab === 'sampling-list',
      onPress: () => setTab('sampling-list'),
    },
    {
      title: 'Kundefordeling',
      active: tab === 'customer-breakdown',
      onPress: () => setTab('customer-breakdown'),
    },
  ]

  return (
    <PageWrapper
      title="Finanstilsynet rapporter"
      description="Kundelister til brug for Finanstilsynets stikprøvekontrol og oversigt over alle kunder."
      tabs={tabs}
    >
      {tab === 'sampling-list' && <SamplingListTab />}
      {tab === 'customer-breakdown' && <CustomerBreakdownTab />}
    </PageWrapper>
  )
}

export default FinanstilsynetScreen
